import THEME_MODE from 'constants/themeMode.const';
import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';

const selectCalendarModes = (state) => {
  const calendarMode = selectCurrentSalonCalendarMode(state);

  const isLightMode = calendarMode === THEME_MODE.light;
  const isDarkMode = calendarMode === THEME_MODE.dark;
  const isBrightMode = !isLightMode && !isDarkMode;

  return { isLightMode, isDarkMode, isBrightMode };
};

// noinspection JSUnusedGlobalSymbols
export default selectCalendarModes;
